<template>
	<AssessmentProfileLayout class="individual-disc-profile"
		:user="user"
		:show-moniker="false"
		:show-descriptors="false"
	>
		<template #primaryHeading>{{ translate( "primaryHeading", { name: user.displayName } ) }}</template>
		<template #primaryCharacteristics>
			<BehaviorCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
			<DrivenCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
			<InfluenceCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
		</template>

		<template #secondaryHeading>{{ translate( "secondaryHeading", { name: user.displayName } ) }}</template>
		<template #secondaryCharacteristics>
			<MeetingCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
			<CommunicationCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
			<CollaborationCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
			<PersuasionCharacteristics
				:high-type="highType"
				:is-skeleton="false"
				:assessment="assessment"
			/>
		</template>
	</AssessmentProfileLayout>
</template>

<script>
import {
	TranslateMixin,
	AssessmentProfileLayout,
	BehaviorCharacteristics,
	MeetingCharacteristics,
	CommunicationCharacteristics,
	CollaborationCharacteristics,
	PersuasionCharacteristics,
	DrivenCharacteristics,
	InfluenceCharacteristics
} from "@teaming/common-ui";

export default {
	name: "IndividualDISCProfile",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	components: {
		AssessmentProfileLayout,
		BehaviorCharacteristics,
		MeetingCharacteristics,
		CommunicationCharacteristics,
		CollaborationCharacteristics,
		PersuasionCharacteristics,
		DrivenCharacteristics,
		InfluenceCharacteristics,
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
	computed: {
		assessment() {
			return this.user?.assessments?.DISC;
		},
		highType() {
			return this.assessment.moniker[ 0 ].toUpperCase();
		},
	},
};
</script>

<style lang="scss">
.individual-disc-profile {
	.disc-profile-layout__header {
		flex-direction: column-reverse;
	}

	.disc-profile-layout__section-row {
		flex-direction: column;
	}
}
</style>
<style lang="scss" scoped>
.individual-disc-profile {
	padding-bottom: 2rem;
}
</style>
